import index from './searchArea'

export default index